import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import { createAutocomplete } from '@algolia/autocomplete-core';

import { Input } from 'antd';
import { RiSearchLine } from 'react-icons/ri';

import pagesData from '../data/algolia-search';
import { NAV_NDES } from '../../../constants';

const HeaderSearch = props => {
  const navigate = useNavigate();
  const [autocompleteState, setAutocompleteState] = useState({});

  const autocomplete = useMemo(
    () =>
      createAutocomplete({
        onStateChange({ state }) {
          setAutocompleteState(state);
        },
        getSources() {
          return [
            {
              sourceId: 'pages-source',
              getItemInputValue({ item }) {
                return item.query;
              },
              getItems({ query }) {
                if (!query) {
                  return pagesData;
                }
                return pagesData.filter((item) => (
                  item.title.toLowerCase().includes(query.toLowerCase())
                ));
              },
              getItemUrl({ item }) {
                return item.url;
              },
              templates: {
                item({ item }) {
                  return (
                    item.title
                  );
                }
              }
            }
          ];
        }
      }),
    []
  );

  function linkHandleClick() {
    autocompleteState.query = '';
    props.setSearchHeader(false);
  }

  return (
    <div {...autocomplete.getRootProps({})}>
      <Input
        {...props.inputFocusProp}
        {...autocomplete.getInputProps({})}
        placeholder="Search..."
        prefix={
          <RiSearchLine className="site-form-item-icon text-color-black-80 text-color-dark-20" />
        }
        onPressEnter={(event) => {
          // If the user just types text and presses enter, navigate to NDEs page with a text filter
          const { value } = event.target;
          if (value) {
            const filters = JSON.stringify([{ field: 'text', operator: 'contains', value }]);
            navigate(`${NAV_NDES}?page=0&pageSize=10&filters=${encodeURIComponent(filters)}`);
          } else {
            navigate(NAV_NDES);
          }
        }}
      />

      <div className="header-search-result" {...autocomplete.getPanelProps({})}>
        {autocompleteState.isOpen
          && autocompleteState.collections.map((collection, index) => {
            const { source, items } = collection;

            return (
              items.length > 0 && (
                <ul key={index} {...autocomplete.getListProps()}>
                  {items.map((item, index) => (
                    index < 4 && (
                      <li
                        key={index}
                        {...autocomplete.getItemProps({
                          item,
                          source
                        })}
                        className="font-weight-500"
                      >
                        <Link
                          to={item.url}
                          onClick={linkHandleClick}
                        >
                          Quick action: {item.title}
                        </Link>
                      </li>
                    )
                  ))}
                </ul>
              )
            );
          })}
      </div>
    </div>
  );
};

HeaderSearch.propTypes = {
  inputFocusProp: PropTypes.object,
  setSearchHeader: PropTypes.func
};

export default HeaderSearch;
